import { render, staticRenderFns } from "./yearRangeWeek.vue?vue&type=template&id=23909f54&scoped=true&"
import script from "./yearRangeWeek.vue?vue&type=script&lang=js&"
export * from "./yearRangeWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23909f54",
  null
  
)

export default component.exports